var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 30C8.268 30 2 23.73 2 16C2 8.27 8.268 2 16 2C23.732 2 30 8.27 30 16C30 23.73 23.732 30 16 30ZM16 0C7.163 0 0 7.16 0 16C0 24.84 7.163 32 16 32C24.837 32 32 24.84 32 16C32 7.16 24.837 0 16 0ZM21.717 10.28C21.323 9.89 20.686 9.89 20.292 10.28L15.994 14.58L11.758 10.34C11.367 9.95 10.733 9.95 10.344 10.34C9.953 10.73 9.953 11.37 10.344 11.76L14.58 15.99L10.314 20.26C9.921 20.65 9.921 21.29 10.314 21.69C10.708 22.08 11.346 22.08 11.74 21.69L16.006 17.42L20.242 21.66C20.633 22.05 21.267 22.05 21.657 21.66C22.048 21.27 22.048 20.63 21.657 20.24L17.42 16.01L21.717 11.71C22.11 11.31 22.11 10.68 21.717 10.28Z",
    fill: "#EB5757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/crossIcon.7e5b16f7522b66c79e58bb191041a034.svg";
export { ForwardRef as ReactComponent };